import { API, graphqlOperation } from "aws-amplify";
import { UPDATE_TIMEZONE, UPDATE_TIMEZONE_SUCCESS, UPDATE_TIMEZONE_FAILURE,RESET_TIMEZONE_STATE } from "../constants";
import { UpdateTimezoneTms } from "./../../queries";

const updateTimezone = (uuId: string, data: any) => {
  return async (dispatch: any) => {
    dispatch({ type: UPDATE_TIMEZONE });
    const updateTimezoneHandle = API.graphql(graphqlOperation(UpdateTimezoneTms, { uuId, data })) as Promise<any>;
    updateTimezoneHandle
      .then(async (updateTimezoneData: any) => {
        if (updateTimezoneData?.data) {
          dispatch({ type: UPDATE_TIMEZONE_SUCCESS, payload: { ...updateTimezoneData } });
        } else {
          dispatch({ type: UPDATE_TIMEZONE_FAILURE });
        }
      })
      .catch((err: any) => {
        dispatch({ type: UPDATE_TIMEZONE_FAILURE });
      });
  };
};

const resetTimezoneState = () => {
  return async (dispatch: any) => {
    dispatch({ type: RESET_TIMEZONE_STATE });
  }  
}

export default {
  updateTimezone,
  resetTimezoneState
};
